import i18n from '_i18n';
import useNavigate from 'Hooks/useNavigate';
import { t } from 'i18next';
import OnboardingBasePage from 'Pages/Common/Onboarding/OnboardingBasePage';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './preauthPages.scss';

interface LanguageOption {
    code: LanguageCode;
    label: string;
}

const LanguageQuestionScreen: React.FC = () => {
    const [selectedLanguage, setSelectedLanguage] =
        useState<LanguageCode | null>(null);
    const navigate = useNavigate();
    const languages: LanguageOption[] = [
        {
            code: 'no',
            label: t('Norwegian'),
        },
        {
            code: 'en',
            label: t('English'),
        },
    ];

    const { country } = useLocation().state || {};

    // Handle user opening "/language" without state. Redirect to auth for user to choose create user or login
    useEffect(() => {
        if (!country) {
            navigate('/auth');
        }
    }, [country]);

    const handleLanguageSelect = (language: LanguageCode) => {
        setSelectedLanguage(language);

        if (i18n.language != language) i18n.changeLanguage(language);
        navigate('/register/name', {
            state: { country, language },
        });
    };

    return (
        <OnboardingBasePage
            showBackButton={true}
            header={t('Which language do you prefer?')}
        >
            <div className="preauth-page-wrapper bottom-content">
                <div className="language-question-screen">
                    <div className="language-options">
                        {languages.map((language) => (
                            <button
                                key={language.code}
                                className={`language-option ${
                                    selectedLanguage === language.code
                                        ? 'selected'
                                        : ''
                                }`}
                                onClick={() =>
                                    handleLanguageSelect(language.code)
                                }
                            >
                                <span className="language-label">
                                    {language.label}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </OnboardingBasePage>
    );
};

export default LanguageQuestionScreen;
